import { render, staticRenderFns } from "./AboutNew.vue?vue&type=template&id=59de89ea&"
import script from "./AboutNew.vue?vue&type=script&lang=js&"
export * from "./AboutNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports